import React from 'react';
import FormObjectsTable from '@/forms/objects/components/FormObjectsTable';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const CatalogueObjectsTable = ({
  category,
  code,
  field,
  text = [],
}) => {
  const items = Array.isArray(text) ? text : [];
  const state = selectors.useCatalogueObjectsTable({
    category,
    code,
    field,
    items,
  });
  const showItem = events.useShowCatalogueObjects(category, { code });
  const deleteItem = events.useDeleteCatalogueObject(category, { code });
  const addItem = events.useAddCatalogueObject(category, { code });
  const updateProperties = events.useUpdateDatasetCatalogueObjectProperties(category, { code });

  return (
    <FormObjectsTable
      addItem={() => addItem({ activeFieldName: field.name, template: state.template })}
      allowAdd={state.allowAdd}
      allowRemove={state.allowRemove}
      canEdit={state.canEdit}
      className="aridhia-catalogue-object-table"
      code={code}
      deleteItem={(index) => deleteItem({ activeFieldName: field.name, activeIndex: index, template: state.template })}
      field={field}
      items={items}
      showItem={(index) => showItem({ activeFieldName: field.name, activeIndex: index, template: state.template })}
      updateProperties={(attributes) => updateProperties({
        ...attributes, activeFieldName: field.name, template: state.template,
      })}
    />
  );
};

export default CatalogueObjectsTable;
